export default "__VITE_ASSET__f67eb789__"